import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Grid, Paper, Skeleton, Typography } from "@mui/material";
import { QuestionsRenderFiltersAutocompleteNumber } from "../../atoms/QuestionsRenderFiltersAutocompleteNumber";
import { QuestionsRenderFiltersAutocompleteSkills } from "../../atoms/QuestionsRenderFiltersAutocompleteSkills";
import { QuestionsRenderFiltersAutocompleteTopics } from "../../atoms/QuestionsRenderFiltersAutocompleteTopics";
import { QuestionsRenderFiltersAutocompleteDifficulty } from "../../atoms/QuestionsRenderFiltersAutocompleteDifficulty";
import { useMst } from "../../../../../mobx";
import { RenderFiltersFormData } from "../../../QuestionsFullRender";

export default function QuestionsRenderFilters({
	onSearch,
}: {
	onSearch: (data: RenderFiltersFormData) => Promise<void>;
}) {
	const methods = useForm<RenderFiltersFormData>();
	const [loading, setLoading] = useState(true);
	const { handleSubmit } = methods;
	const { topicsStore, skillsStore } = useMst();
	const { getSkills } = skillsStore;
	const { getTopics } = topicsStore;

	useEffect(() => {
		async function getInfoAsync() {
			setLoading(true);
			await getSkills();
			await getTopics();
			setLoading(false);
		}

		getInfoAsync();
	}, []);

	return (
		<Paper
			elevation={4}
			component={"form"}
			sx={(theme) => ({ width: "100%", margin: theme.spacing(2, 0), padding: theme.spacing(1, 3, 3, 3) })}
		>
			<Grid container item xs={12}>
				<Typography variant={"h6"} marginY={1}>
					Фильтр
				</Typography>
			</Grid>
			<Grid container rowGap={2}>
				<Grid container item xs={12} columnGap={2} rowGap={1}>
					<FormProvider {...methods}>
						{loading ? (
							<>
								<Grid item xs={12}>
									<Skeleton height={54} />
								</Grid>
								<Grid item xs={12}>
									<Skeleton height={54} />
								</Grid>
								<Grid item xs={12}>
									<Skeleton height={54} />
								</Grid>
								<Grid item xs={12}>
									<Skeleton height={54} />
								</Grid>
							</>
						) : (
							<>
								<QuestionsRenderFiltersAutocompleteNumber />
								<QuestionsRenderFiltersAutocompleteSkills />
								<QuestionsRenderFiltersAutocompleteTopics />
								<QuestionsRenderFiltersAutocompleteDifficulty />
							</>
						)}
					</FormProvider>
				</Grid>
				<Grid item>
					<Button size={"small"} type={"submit"} variant={"contained"} onClick={handleSubmit(onSearch)}>
						Поиск
					</Button>
				</Grid>
			</Grid>
		</Paper>
	);
}
